import { RotateCcw } from "lucide-react";

interface RetryButtonProps {
  onRetry: () => void;
}

const RetryButton = ({ onRetry }: RetryButtonProps) => (
  <button
    onClick={onRetry}
    className="flex items-center gap-1 text-xs text-primary hover:underline mt-1 px-1"
  >
    <RotateCcw className="h-3 w-3" />
    Retry
  </button>
);

export default RetryButton;
